var _defs, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "7px",
    viewBox: "0 0 126 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shadow-large copy 34") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50.3201244%",
    fx: "50%",
    fy: "50.3201244%",
    r: "42.199855%",
    gradientTransform: "translate(0.500000,0.503201),scale(0.069231,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.503201)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.12538243,
    offset: "0.279771959%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Home-page-\\u2013-Promo-panel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Home-page-\\u2013-Promo-panel-Copy-3",
    transform: "translate(-129.000000, -582.000000)",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow-Large",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(127.000000, 581.000000)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow-copy",
    cx: 65,
    cy: 4.5,
    rx: 65,
    ry: 4.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShadow);
export default __webpack_public_path__ + "static/media/icon-shadow.b2d81d8ecac3b4657654c6689a2a476a.svg";
export { ForwardRef as ReactComponent };